module.exports = __webpack_public_path__ + "static/media/app_logo.ecca5263.png";